import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roundPipe',
    standalone: false
})
export class RoundPipePipe implements PipeTransform {

  transform(input: number): number {
    return Math.round(input);
  }

}
